var artists = [
    {
        name: "Grant Dersom",
        image: require('../assets/profile-photo-small.jpg'),
        books:
            [
            {
                title: "24 Waltzes",
                chapters: [
                    {
                        title: "Waltz No. 7",
                        link: "https://www.sheetmusicplus.com/title/waltz-no-7-digital-sheet-music/21756886?aff_id=699623",
                        image: require("../assets/op-1/no 7.png")
                    },
                    {
                        title: "Waltz No. 12",
                        link: "https://www.sheetmusicplus.com/title/waltz-no-12-digital-sheet-music/21756923?aff_id=699623",
                        image: require("../assets/op-1/no 12.png")
                    },
                    {
                        title: "Waltz No. 21",
                        link: "https://www.sheetmusicplus.com/title/waltz-no-21-digital-sheet-music/21756921?aff_id=699623",
                        image: require("../assets/op-1/no 21.png")
                    }
                ],
                subtitle: "Opus 1",
                author: "Grant Dersom",
                short_description: "<p>A beatiful collection of waltzes for piano, in every major and minor key.</p>",
                description:
                    `The 24 Waltzes represent fledgling composer Grant Dersom’s <b>first published work</b> in the classical genre; he wrote these waltzes in 2018 over a period of about six months, being only 19-20 years old. Having independently studied the works of many great composers, Dersom’s waltzes show a <b>great diversity of styles</b>; for example, Waltz No. 9 brings thoughts of Chopin’s mazurkas, Waltz No. 7 emphasizes certain dissonance, and Waltz No. 16 is jazz-like in nature. 
            <br><br>Inside, the composer includes a foreword, performance notes, and a series of clarifications and definitions. The cover is given a modern, glossy finish.
        <br><br>To view more information about the book, you can use the link under the book cover, which goes to our Amazon product listing.      
        <br><br><h3>Listening options</h3>
        <b>YouTube</b> (not all 24 are here yet!)
        <iframe width="560" height="315" style="width: 100%" src="https://www.youtube.com/embed/videoseries?list=PLd24CIFAHXuCtEUJTZ_R6AmymsycCSHgb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <br><br>We have also released an album from this book! <a href="/music/The-First-12-Waltzes">Click here</a> for more info.
        `,
                subtext: "",
                link: "https://amzn.to/3UVinpi",
                images: [
                ],
                sampleAudio: [
                ],
                audioDescription: "",
                sampleVideo: "",
                // '<iframe width="75%" height="100%" style="max-width: 400px;" class="text-center" src="https://www.youtube-nocookie.com/embed/tLeHDWxhxP8?start=95" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                amazonURL:
                    'https://amzn.to/3UVinpi',
                itemImage: require("../assets/op-1/24 waltzes front cover.jpg"),
                buttons: [
                    {
                        type: "downloadReview",
                        name: "Download Free PDF",
                        href: "/static/24 Waltzes.pdf",
                        reviewURL: "https://www.amazon.com/24-Waltzes-Opus-Grant-Dersom/dp/0578566427",
                        theme: "success"
                    },
                    {
                        type: "shop",
                        name: "View on Amazon",
                        url: 'https://amzn.to/3UVinpi',
                        theme: "info"
                    }
                ]

            },
            {
                title: "12 Grand Waltzes",
                chapters: [],
                subtitle: "Opus 1b",
                author: "Grant Dersom",
                short_description: "<p>A set of simplified waltzes for piano.<br> Includes selected waltzes, made easier, from Opus 1.</p>",
                description: `
            <div>
            <i>"★★★★★ - A delightful and rewarding pursuit for pianists everywhere...Striking a balance between being warmly approachable and charmingly complex, 12 Grand Waltzes is a gratifying journey for any pianist to embark upon."</i> <b>- Nicky Flowers, Indies Today</b><br><br>
            <a style="float: right;" href="https://indiestoday.com/12-grand-waltzes-by-grant-dersom/" target="_blank">
            <img src="https://indiestoday.com/wp-content/uploads/2019/11/RecommendedBadge.png" alt="Indies Today Recommended" height="75" width="75">
            </a>

            <b>New and exciting</b><br>
            The 12 Grand Waltzes contain a beautiful set of piano songs from the living, modern composer Grant Dersom. Being inspired from the music of Chopin, Beethoven, and others, these waltzes nonetheless exhibit their own brand of melodic charm and sophistication.<br><br>

            <b>Simplified for your enjoyment</b><br>
            While being a joy to perform, these waltzes were made easier from Dersom's 24 Waltzes (Op. 1) by the composer himself, ensuring they are true to the originals.
            </div>

            <br><b>Audio sample</b>
            <div style="font-size: 12px;">From the original, unsimplified book</div>
            <a onclick="window._paq.push(['trackEvent', 'Outbound', 'Click', 'Youtube opus 1b']); window.setTimeout(function(){window.location.href = 'https://www.youtube.com/watch?v=3e3LUPMJLkw'},500)">View on YouTube</a>
            <br><iframe sandbox="allow_scripts" style="width: 100%; max-width: 300px;" data-src="https://open.spotify.com/embed/track/43yuk2ALMnritNA1P4ge8m" width="250" height="80" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
            
            <br><br><h4>Contents</h4>
            <div style="font-size: 12px;">(simplified versions)</div>
            <div style="display: flex;">
                <div style="flex: 50%;">        
                    <ul><li>Waltz No. 1 in C major</li>
                    <li>Waltz No. 3 in C minor</li>
                    <li>Waltz No. 5 in B minor</li>
                    <li>Waltz No. 6 in C♯ minor</li>
                    <li>Waltz No. 7 in E minor</li>
                    <li>Waltz No. 9 in A♭ major</li></ul>
                </div>
                <div style="flex: 50%;">
                    <ul><li>Waltz No. 11 in G major</li>
                    <li>Waltz No. 12 in E major</li>
                    <li>Waltz No. 16 in E♭ major</li>
                    <li>Waltz No. 17 in A minor</li>
                    <li>Waltz No. 18 in B♭ major</li>
                    <li>Waltz No. 24 in F major</li></ul>
                </div>
            </div>`,
                subtext: "",
                link: "https://amzn.to/3WkrMrx",
                images: [],
                sampleAudio: [],
                audioDescription: "",
                sampleVideo: "",
                amazonURL: 'https://amzn.to/3WkrMrx',
                itemImage: require("../assets/op-1b/front cover optimized.jpg"),
                buttons: [
                    {
                        type: "downloadReview",
                        name: "Download Free PDF",
                        href: "/static/12 Grand Waltzes free sheet music.pdf",
                        reviewURL: "https://www.amazon.com/review/create-review/?asin=173777190X",
                        theme: "success"
                    },
                    {
                        type: "shop",
                        name: "View on Amazon",
                        url: "https://amzn.to/3WkrMrx",
                        theme: "info"
                    }
                ]
            },
            {
                title: "5 Nocturnes",
                chapters: [],
                subtitle: "Opus 2",
                author: "Grant Dersom",
                short_description: "<p>An evocative set of original Nocturnes.</p>",
                description:
                    `Embark on a mesmerizing journey of lyrical expression with Grant Dersom's Nocturnes.
                This collection of five original compositions sequentially traverses a depth of profound moods.
                From gentle introspection to haunting melancholy, each piece captures the essence of nocturnal solitude.<br>
                <i>Includes notes from the composer, pedal marks, and fingerings.</i>
        <br><br>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/SJcbsFnFD-A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        `,
                subtext: "",
                link: "https://amzn.to/3qJYZCs",
                images: [
                ],
                sampleAudio: [
                ],
                audioDescription: "",
                sampleVideo: "",
                // '<iframe width="75%" height="100%" style="max-width: 400px;" class="text-center" src="https://www.youtube-nocookie.com/embed/tLeHDWxhxP8?start=95" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                amazonURL:
                    'https://amzn.to/3qJYZCs',
                itemImage: require("../assets/op-2/front cover.jpg"),
                buttons: [
                    {
                        type: "downloadReview",
                        name: "Download Free PDF",
                        href: "/static/5 Nocturnes.pdf",
                        reviewURL: "https://www.amazon.com/dp/1737771918",
                        theme: "success"
                    },
                    {
                        type: "shop",
                        name: "View on Amazon",
                        url: 'https://amzn.to/3qJYZCs',
                        theme: "info"
                    },
                ]

            },
            {
                title: "Sentiments",
                chapters: [],
                subtitle: "Opus 3",
                author: "Grant Dersom",
                short_description: "<p>A dreamlike, seven-movement suite.</p>",
                description:
                    `<b>Original piano pieces</b><br>
A melancholic yet dreamlike suite, Dersom's Sentiments detail a seven-movement journey through subtle and elegant scenes. Includes the shimmering Prelude, the hollow Solitude, and the cascading, contrapuntal Siren.
To assist the pianist, the composer has included pedal marks and fingerings.<br><br>
<b>
Movements<br>
I. Prelude<br>
II. Gavotte-March<br>
III. Solitude<br>
IV. Mirror<br>
V. Waltz<br>
VI. Siren<br>
VII. Conclusion<br>
</b>
        `,
                subtext: "",
                link: "",
                images: [
                ],
                sampleAudio: [
                ],
                audioDescription: "",
                sampleVideo: "",
                amazonURL:
                    '',
                itemImage: require("../assets/op-3/front cover.jpg"),
                buttons: [
                    {
                        type: "downloadReview",
                        name: "Download Free PDF",
                        href: "/static/Sentiments.pdf",
                        reviewURL: "https://www.amazon.com/dp/1737771950",
                        theme: "success"
                    },
                    {
                        type: "shop",
                        name: "View on Amazon",
                        url: 'https://www.amazon.com/dp/1737771950',
                        theme: "info"
                    },
                ]
            }],
    },
    {
        name: "Modernized Classics",
        books:
            [{
                chapters: [],
                title: "3 Gymnopedies",
                subtitle: "Zero Page Turns Edition",
                author: "Erik Satie",
                short_description: "<p>Erik Satie's classic works, with modern editing by Grant Dersom.</p>",
                description:
                    `Among the more popular works by French composer Erik Satie (1866-1925) are the Three Gymnopédies, which showcase a curious perspective on piano expression. Drawing from the original manuscript and other sources, modern composer Grant Dersom brings together this set as a "Zero page turn" edition, so that each piece can be enjoyed without interruption.

                <br><br>As a "Zero page turn" edition, this book has each piece set within only a left and right page, allowing the pianist to play each song without having to worry about page turns.
            `,
                subtext: "",
                link: "https://amzn.to/3YLhR0m",
                images: [
                ],
                sampleAudio: [
                ],
                audioDescription: "",
                sampleVideo: "",
                // '<iframe width="75%" height="100%" style="max-width: 400px;" class="text-center" src="https://www.youtube-nocookie.com/embed/tLeHDWxhxP8?start=95" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
                amazonURL:
                    'https://amzn.to/3YLhR0m',
                itemImage: require("../assets/3-gymn/front cover 1.7.jpg"),
                buttons: [
                    {
                        type: "shop",
                        name: "Shop Print and Digital",
                        url: 'https://amzn.to/3YLhR0m',
                        theme: "info"
                    }
                ]
            },
            {
                chapters: [],
                title: "Clair de Lune",
                subtitle: "Modern Edition",
                author: "Claude Debussy",
                short_description: "<p>Debussy's masterpiece, with modern editing by Grant Dersom.</p>",
                description:
                    `Perhaps the most famous work of Claude Debussy (1862-1913) is Clair de Lune, from the Suite Bergamasque. 
                <br><br>In this Modern Edition, contemporary composer Grant Dersom rejuvenates the printed score by editing with modern techniques, complete with fingerings, pedal indications, and supplementary information.
            `,
                subtext: "",
                link: "https://amzn.to/3GUJ8W4",
                images: [],
                sampleAudio: [],
                audioDescription: "",
                sampleVideo: "",
                amazonURL: 'https://amzn.to/3GUJ8W4',
                itemImage: require("../assets/clair-de-lune/cover 1.3 first page.jpg"),
                buttons: [
                    {
                        type: "shop",
                        name: "Shop Print and Digital",
                        url: 'https://amzn.to/3GUJ8W4',
                        theme: "info"
                    }
                ]
            },
            {
                chapters: [],
                title: "Practical Method for Beginners",
                subtitle: "Modern Edition",
                author: "Carl Czerny",
                short_description: "<p>Includes 100 Exercises, and an introduction on reading sheet music.</p>",
                description:
                    `An excellent guide for budding pianists, Czerny's Practical Method for Beginners has served as an instructional beacon for over 150 years.
In this Modern Edition, contemporary composer Grant Dersom rejuvenates the printed score by editing with modern techniques, while drawing from reliable, older editions.
Includes fingerings, footnotes, and "Notes for Absolute Beginners": an introductory guide on reading sheet music.
            `,
                subtext: "",
                link: "",
                images: [],
                sampleAudio: [],
                audioDescription: "",
                sampleVideo: "",
                amazonURL: '',
                itemImage: require("../assets/practical-method/front cover.jpg"),
                buttons: [
                    {
                        type: "shop",
                        name: "Shop Print and Digital",
                        url: 'https://a.co/d/863sjO3',
                        theme: "info"
                    }
                ]
            },
            ]
    }
]

export default artists
